import React from 'react';
import {useAtom} from "jotai";
import {filteredNodesAtom, finishedAtom} from "../../atoms/atoms";
import styled from "styled-components/macro";
import colors from "../../styles/variables/colors";
import Colors from "../../styles/variables/colors";
import ReactGA from "react-ga4";

export const ActionButton = styled.button`
  display: block;
  box-sizing: border-box;
  background-color: ${colors.slate.base};
  width: calc(100% - 30px);
  text-align: left;
  padding: 13px 15px;
  margin: 10px auto 18px;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: ${colors.slate["80"]};
  }
`;

export const Claim = styled.span`
  font-family: "Helvetica Now Micro W01 Medium", sans-serif;
  display: block;
  width: 100%;
  color: ${Colors.white.base};
  font-size: 13px;
`;

export const Action = styled.span`
  color: ${colors.white.base};
  font-family: 'Helvetica Now Text W01 Bold', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 110%;
`;

export const FilteredNodeButton = () => {
  const [, setFinished] = useAtom(finishedAtom);
  const [filteredNodes] = useAtom(filteredNodesAtom);

  const updateFilterState = () => {
    setFinished(true);
    localStorage.setItem('sopm_filter_result_view', 'true');
    ReactGA.event({
      category: 'ProductFinder',
      action: 'Show Product Results',
      label: 'Show Product Results'
    });
  }

  return (
    <ActionButton onClick={updateFilterState}>
      <Claim>Alle anzeigen</Claim>
      <Action key={'display:nodes'}>{filteredNodes.length} Werbeformat{filteredNodes.length > 1 && 'e'}</Action>
    </ActionButton>
  );
}

export default FilteredNodeButton;
